import { lm } from "@netent-tech/layout-manager";

const gameConfig = {
    isLegacy: true,
    keypadType: "playui",
    canvasSize: {
        base: {
            width: 1280,
            height: 720
        },
        desktop: {
            width: 1280,
            height: 720
        },
        tablet: {
            width: 960,
            height: 540
        },
        mobile: {
            width: 960,
            height: 540
        }
    }
};

window.LayoutManager = lm(gameConfig);